import FilterContainer from './adapter';

export default FilterContainer;
